<template>
  <v-main>
    <!--Dont use component using Basic Layout. causes bug on show layout above panel loaded 2 times -->
    <TheAppAbovePanel
      v-if="!basic"
      class="main__header"
      :has-scrollbar="hasScrollbar"
      :is-at-top="isAtTop"
      :collapse="scrolledDown"
    />

    <div
      class="main__container"
      ref="scrollContainer"
      v-scroll.self.passive="onScroll"
      @wheel.passive="onWheel"
    >
      <LayoutContentContainer>
        <slot />
      </LayoutContentContainer>
    </div>
  </v-main>
</template>

<script>
import LayoutContentContainer from '@/components/LayoutContentContainer.vue';
import TheAppAbovePanel from './TheAppAbovePanel.vue';

export default {
  name: 'AppCardWrapper',
  components: {
    LayoutContentContainer,
    TheAppAbovePanel,
  },
  props: {
    basic: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    lastScrollPosition: 0,
    currentScrollPosition: 0,
    wheelDeltaY: 0,
    hasScrollbar: false,
    scrollObserver: null,
  }),
  computed: {
    isAtTop() {
      return this.currentScrollPosition === 0;
    },
    scrolledDown() {
      // TODO: Add inertia, minimum threshold, or in-between states for less janky movement
      return (
        this.wheelDeltaY > 0 || // on desktop, watch for wheel event
        this.currentScrollPosition > this.lastScrollPosition // on tablet/mobile, the screen size won't change as freely, and scroll can be used
      );
    },
  },
  mounted() {
    this.initScrollObserver();
  },
  beforeDestroy() {
    this.cleanup();
  },
  methods: {
    initScrollObserver() {
      if (!window.ResizeObserver) return; // guard against unsupported browsers

      this.scrollObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          const { target } = entry;
          const hasScrollbar = target.scrollHeight > target.clientHeight;
          if (this.hasScrollbar !== hasScrollbar) {
            this.hasScrollbar = hasScrollbar;
          }
        }
      });

      this.$nextTick(() => {
        const container = this.$refs.scrollContainer;
        if (container) {
          this.scrollObserver.observe(container);
          // Set initial scrollbar state
          this.hasScrollbar = container.scrollHeight > container.clientHeight;
        }
      });
    },
    cleanup() {
      if (this.scrollObserver) {
        this.scrollObserver.disconnect();
        this.scrollObserver = null;
      }
    },
    onWheel(event) {
      this.wheelDeltaY = event.deltaY;
    },
    // onResize() {
    //   if (!this.$refs?.scrollContainer) return;
    //   const el = this.$refs.scrollContainer;
    //   this.hasScrollbar = el.offsetWidth - el.clientWidth > 0;
    // },
    onScroll(event) {
      // TODO: use scroll store module, so UserLayout and views can use the content scroll position
      if (!event?.target) return;

      this.lastScrollPosition = this.currentScrollPosition;
      this.currentScrollPosition = event.target.scrollTop;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-main::v-deep {
  max-height: 100%;

  > .v-main__wrap {
    max-height: 100%;
    display: flex;
    flex-direction: column;
  }
}

.main__header {
  z-index: 1;
  flex: 0 0 auto;
}

.main__container {
  will-change: padding-top, margin-top;
  transition: all $primary-transition;
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: auto;
  z-index: 0;
}
</style>
